import { guidedSetupAllowed } from '../pages/guided-setup/guided-setup-model';
import {
  closedStages,
  type WorkflowStage,
} from '../stores/utils/workflow-stage';
import { useBobcatFlag } from './use-bobcat-flag';

/**
 * The five-stage nav's stages that their own flag keeps closed (PSTUDIO-4583).
 * One definition for the nav that grays them out and the page that refuses to
 * render them, so the two cannot disagree. A flag LaunchDarkly has not
 * answered yet (`pending`) counts as closed, like every other Bobcat surface.
 */
export const useClosedStages = (): WorkflowStage[] => {
  const validate = useBobcatFlag('validateStage') === 'allowed';
  const observe = useBobcatFlag('observeStage') === 'allowed';
  return closedStages({ validate, observe });
};

/**
 * Whether guided setup runs: only when the master, Validate and Observe are
 * all on (Leo, 2026-10-26, PSTUDIO-4636). It has no switch of its own; the rule
 * lives in `guidedSetupAllowed` (PSTUDIO-4583). Every guided-setup entrance asks
 * this one hook: the wizard that starts it, the header nav and the coach card.
 */
export const useGuidedSetupEnabled = (): boolean => {
  const master = useBobcatFlag('fiveStageNav') === 'allowed';
  const validate = useBobcatFlag('validateStage') === 'allowed';
  const observe = useBobcatFlag('observeStage') === 'allowed';
  return guidedSetupAllowed({
    master,
    validate,
    observe,
  });
};
